import React from "react";

const CompletionScreen = ({ subtotal, allSelectedOptions }) => {
  return (
    <div className="py-4">
      <h4 style={{ color: "#28a745", marginBottom: "24px" }}>✓ All options selected!</h4>
      
      {allSelectedOptions && allSelectedOptions.length > 0 && (
        <div className="mb-3 p-3" style={{ backgroundColor: "#1a1a1a", borderRadius: "8px", border: "1px solid #333" }}>
          <h6 className="mb-3" style={{ color: "#fff" }}>Selected Options:</h6>
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            {allSelectedOptions.map((item, idx) => (
              <div key={idx} className="d-flex justify-content-between mb-2 pb-2" style={{ borderBottom: "1px solid #333" }}>
                <span style={{ color: "#ccc" }}>
                  <strong style={{ color: "#fff" }}>{item.addonTitle}:</strong> {item.option}
                </span>
                {item.price > 0 && (
                  <span style={{ color: "#28a745" }}>+${item.price.toFixed(2)}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      
      <p style={{ color: "#aaa", fontSize: "14px", marginTop: "16px" }}>Press Enter to add to cart</p>
    </div>
  );
};

export default CompletionScreen;
